export const AlertMainStyle:React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  width:"100%",
  height:"100%",
  alignItems: "center",
}

export const AlertRadiusColorStyle:React.CSSProperties = {
  width:"8px",
  alignSelf:"stretch",
  borderRadius: "8px 0px 0px 8px",
}

export const AlertBodyStyle:React.CSSProperties = {
  display:"flex",
  flexDirection:"row",
  padding:"24px",
  gap:"24px",
  width:"100%",
  alignItems: "center",  
  flex:"1 0 0",
  justifyContent:"left",
  borderRadius: "0px 8px 8px 0px",
  borderTop: "1px solid #E8E8E8",
  borderRight: "1px solid #E8E8E8",
  borderBottom: "1px solid #E8E8E8",
  background: "#FFF",
  boxShadow: "2px 2px 2px 0px rgba(0, 0, 0, 0.08)",
  color: "#333",
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: "FS Elliot Pro Regular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "21px"
}

export const DetalleNoConfirmadoStyle: React.CSSProperties = {
  display:"flex",
  flexDirection:"row",
  border:"1px solid #ccc",
  borderRadius:"5px",
  padding: "10px",
}